import React from "react";
import { Container, Form, Image } from "react-bootstrap";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import call from "../../../Asset/call.png";
import mail from "../../../Asset/mail.png";
import location from "../../../Asset/location.png";
import { FaLinkedinIn } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { FaFacebookF } from "react-icons/fa";
import { ErrorMessage, Field, Formik } from "formik";
import * as Yup from "yup";
import "./First.css";
import clutch from "../../../Asset/clutch.svg";
import arrow from "../../../Asset/arrow.svg";
import google from "../../../Asset/google review.png";
import upwork from "../../../Asset/upwork-png-1.png";
import emailjs from "emailjs-com";
import { FaXTwitter } from "react-icons/fa6";

const CareersSection = () => {
  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required("First Name is required")
      .min(2, "First Name must be at least 2 characters"),
    lastName: Yup.string()
      .required("Last Name is required")
      .min(2, "Last Name must be at least 2 characters"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    phoneNumber: Yup.string()
      .required("Phone Number is required")
      .matches(/^[0-9]{10}$/, "Phone Number must be exactly 10 digits"),
    message: Yup.string(),
  });

  const sendEmail = (formData, resetForm) => {
    emailjs
      .send(
        process.env.REACT_APP_CONTECT_SERVICE_ID,
        process.env.REACT_APP_CONTECT_TEMPLATE_ID,
        {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          phoneNumber: formData.phoneNumber,
          message: formData.message,
        },
        process.env.REACT_APP_CONTECT_PUBLIC_ID,
      )
      .then(
        (result) => {
          alert("Your info is sent successfully!");
          resetForm();
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          alert("Failed to send your info.");
        },
      );
  };

  return (
    <div className="careers-section contact-us">
      <Container>
        <div className="card">
          <div className="row spacing">
            <div className="info col-lg-4 col-md-12 d-flex flex-column justify-content-between">
              <div className="contact-details main-title contact-section">
                <h1>Contact Information</h1>
                <p className="sort-info">
                  Send us a message, and we'll reply faster than a cat chasing a
                  laser beam!
                </p>
                <div className="contact-info">
                  <div className="details d-flex align-items-center">
                    <Image src={call} alt="Call Icon" />
                    <a href="tel:+919726012626">
                      <span>+91 97260-12626</span>
                    </a>
                  </div>
                  <div className="details d-flex align-items-center">
                    <Image src={mail} alt="Mail Icon" />
                    <a href="mailto:codeffitech@gmail.com">
                      <span>codeffitech@gmail.com</span>
                    </a>
                  </div>
                  <div className="details d-flex align-items-center">
                    <Image src={location} alt="Location Icon" />
                    <a
                      href="https://www.google.com/maps/place/Angel+Business+Center+%2F+ABC+mall+1/@21.2405862,72.8751736,17z/data=!3m1!4b1!4m6!3m5!1s0x3be04fb5f5a392a1:0xe39a3748b0358250!8m2!3d21.2405862!4d72.8777485!16s%2Fg%2F11h3k5cz34?authuser=0&entry=ttu&g_ep=EgoyMDI1MDIyNi4xIKXMDSoASAFQAw%3D%3D"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>Mota Varchha</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="social-icons d-flex">
                <a
                  href="https://www.linkedin.com/company/codeffi"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaLinkedinIn className="icon" />
                </a>
                <a
                  href="https://www.instagram.com/codeffiinfotech/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <AiFillInstagram className="icon" />
                </a>
                <a
                  href="https://www.facebook.com/codeffi"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebookF className="icon" />
                </a>
                <a
                  href="https://x.com/codiffi"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaXTwitter className="icon" />
                </a>
              </div>
            </div>
            <div className="col-lg-8 col-md-12 contact-form">
              <div className="main-form">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={(values, { resetForm }) => {
                    sendEmail(values, resetForm);
                  }}
                >
                  {({ errors, touched, handleSubmit }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <Form.Floating>
                              <Field
                                as={Form.Control}
                                id="inputCustom"
                                name="firstName"
                                placeholder="First Name*"
                                isInvalid={
                                  touched.firstName && errors.firstName
                                }
                              />
                              <label htmlFor="firstName">First Name*</label>
                              <ErrorMessage
                                name="firstName"
                                component="div"
                                className="text-danger"
                              />
                            </Form.Floating>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <Form.Floating>
                              <Field
                                as={Form.Control}
                                id="inputCustom"
                                name="lastName"
                                placeholder="Last Name*"
                                isInvalid={touched.lastName && errors.lastName}
                              />
                              <label htmlFor="lastName">Last Name*</label>
                              <ErrorMessage
                                name="lastName"
                                component="div"
                                className="text-danger"
                              />
                            </Form.Floating>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <Form.Floating>
                          <Field
                            as={Form.Control}
                            id="inputCustom"
                            name="email"
                            type="email"
                            placeholder="Email ID*"
                            isInvalid={touched.email && errors.email}
                          />
                          <label htmlFor="email">Email ID*</label>
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Floating>
                      </div>
                      <div className="form-group">
                        <Form.Floating>
                          <Field
                            as={Form.Control}
                            id="inputCustom"
                            name="phoneNumber"
                            placeholder="Phone Number*"
                            isInvalid={
                              touched.phoneNumber && errors.phoneNumber
                            }
                          />
                          <label htmlFor="phoneNumber">Phone Number*</label>
                          <ErrorMessage
                            name="phoneNumber"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Floating>
                      </div>
                      <div className="form-group">
                        <FloatingLabel
                          controlId="floatingTextarea2"
                          label="Message (Optional)"
                        >
                          <Field
                            as={Form.Control}
                            id="inputCustom"
                            name="message"
                            placeholder="Message (Optional)"
                            style={{ height: "150px" }}
                          />
                        </FloatingLabel>
                      </div>
                      <div className="form-group">
                        <div className="action-btn">
                          <p>
                            <button
                              type="submit"
                              className="submit-btn btn btn-black"
                            >
                              Send
                            </button>
                          </p>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
              <div className="main-section wo-milestone">
                <div className="milestone-counts-wrapper">
                  <div className="milestone-review-card custom-spacing d-flex">
                    <span className="review-img-card">
                      <a
                        href="https://clutch.co/profile/codeffi-infotech"
                        target="_blank"
                      >
                        <Image src={clutch} />
                        <Image src={arrow} className="svg" />
                      </a>
                    </span>
                    <div class="review-divider"></div>
                    <span className="review-img-card">
                      <Image src={google} />
                      <Image src={arrow} className="svg" />
                    </span>
                    <div class="review-divider"></div>
                    <span className="review-img-card">
                      <a
                        href="https://www.upwork.com/freelancers/chiragb48"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Image src={upwork} />
                        <Image src={arrow} className="svg" />
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CareersSection;
